import {
    GET_RIDES_ALL_LIST_START,
    GET_RIDES_ALL_LIST_ERROR,
    GET_RIDES_ALL_LIST_SUCCESS,
    GET_RIDES_AVAILABLE_LIST_SUCCESS,
    GET_RIDES_ON_TOUR_LIST_SUCCESS,
    GET_RIDES_ASSIGNED_LIST_SUCCESS,
    GET_RIDES_MAINTENANCE_LIST_SUCCESS,
    GET_UNDER_VERIFICATION_RIDES_LIST_START,
    GET_UNDER_VERIFICATION_RIDES_LIST_SUCCESS,
    GET_UNDER_VERIFICATION_RIDES_LIST_ERROR
} from "../Constants/OperatorFleetConstant";


const initialState = {
    loading: false,
    operatorRidesAllList: [],
    operatorRidesAvailableList: [],
    operatorRidesOnTourList: [],
    operatorRidesAssignedList: [],
    operatorRidesMaintenanceList: [],
    underVerificationList: [],
};
export default function OperatorFleetReducer(state = { ...initialState }, action) {
    switch (action.type) {
        case GET_RIDES_ALL_LIST_START:
        case GET_UNDER_VERIFICATION_RIDES_LIST_START:
            return {
                ...state,
                loading: true,
            };
            case GET_RIDES_ALL_LIST_SUCCESS:
                return {
                  ...state,
                  operatorRidesAllList: action.payload,
                  loading: false,
                };
              case GET_RIDES_AVAILABLE_LIST_SUCCESS:
                return {
                  ...state,
                  operatorRidesAvailableList: action.payload,
                  loading: false,
                };
              case GET_RIDES_ON_TOUR_LIST_SUCCESS:
                return {
                  ...state,
                  operatorRidesOnTourList: action.payload,
                  loading: false,
                };
              case GET_RIDES_ASSIGNED_LIST_SUCCESS:
                return {
                  ...state,
                  operatorRidesAssignedList: action.payload,
                  loading: false,
                };
              case GET_RIDES_MAINTENANCE_LIST_SUCCESS:
                return {
                  ...state,
                  operatorRidesMaintenanceList: action.payload,
                  loading: false,
                };
                case GET_UNDER_VERIFICATION_RIDES_LIST_SUCCESS:
                  return {
                    ...state,
                    underVerificationList: action.payload,
                    loading: false,
                  };
              case GET_RIDES_ALL_LIST_ERROR:
              case GET_UNDER_VERIFICATION_RIDES_LIST_ERROR:
                return {
                    ...state,
                    loading: false,
                    message: action.error.message,
                };
        default:
            return state;
    }
}